/**
 * 通用的接口
 */
import requestByGateway from '@/request/request.gateway';
import base from '@/config';

let req = {
	method: 'get'
};
// 网关get
let getWayRequest = (data, url) => {
	req.params = data;
	req.url = url;
	return requestByGateway(req);
};

const common = {
	//获取学校列表
	getSchoolList(data) {
		return getWayRequest(data, base.api.pos + '/consume/school/list');
	},
	//获取学校列表(新版，人脸识别)
	getSchoolListNew(data) {
		return getWayRequest(data, base.api.face + '/publics/v1/school-list');
	},
	// 获取设备列表
	getEqtList(data) {
		return getWayRequest(data, base.api.pos + '/consume/devices/list');
	},
	// 获取商户列表
	getMerchantList(data) {
		return getWayRequest(data, base.api.pos + '/consume/merchant/list');
	},
	// 获取班级列表
	getClassList(data) {
		return getWayRequest(data, base.api.pos + '/consume/class/list');
	},
	// 获取操作人员列表
	getOperatorList(data) {
		return getWayRequest(data, base.api.pos + '/consume/operator/list');
	},
	// 获取年级列表
	getLinkageGrade(data) {
		return getWayRequest(
			data,
			`${base.api.admin}/SchoolStruct/Class/get_grade_list_by_schoolid`
		);
	},
	// 获取年级列表
	getLinkageClass(data) {
		return getWayRequest(
			data,
			`${
				base.api.admin
			}/SchoolStruct/Class/get_class_list_by_schoolid_or_gradeid`
		);
	},
	/**
	 * 获取年级班级列表
	 */
	getGradeClass(params) {
		return requestByGateway({
			method: 'get',
			url: `${
				base.api.admin
			}/SchoolStruct/Class/get_grade_class_list_by_schoolid`,
			headers: base.headers,
			params
		});
	}
};

export default common;
